import ErrorComponent from "@/components/atoms/ErrorComponent";
import OrganisationHeader from "@/components/molecules/card-headers/organisations/OrganisationHeader";
import OrganisationEditCard from "@/components/molecules/cards/organisations/OrganisationEditCard";
import { UUID_REGEX } from "@/constants/regexs";
import { FC } from "react";
import { useParams } from "react-router-dom";

const OrganisationEditView: FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page formalys-edit-page">
      <OrganisationHeader id={id} isEdit />
      <OrganisationEditCard id={id} />
    </div>
  );
};

export default OrganisationEditView;
